<div>
  <div
    class="progress {{color}}"
    [class.animated]="animated"
    [ngStyle]="{width: (numerator / denominator*100) + '%'}"
  ></div>

  @if (numerator / denominator && showPercentage) {
    <div class="tally">
      {{ (numerator / denominator * 100).toFixed(0) }}%
    </div>
  }

  @if (!numerator && zeroProgressText && showPercentage) {
    <div class="tally">
      {{ zeroProgressText }}
    </div>
  }
</div>
